import transactionsMetaReducer from './transactionsMetaReduce';

export default transactionsMetaReducer;
